
import React from 'react';
import { FormLabel } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';

interface ScreenshotFieldProps {
  screenshot: File | undefined;
  setScreenshot: React.Dispatch<React.SetStateAction<File | undefined>>;
}

export const ScreenshotField: React.FC<ScreenshotFieldProps> = ({ 
  screenshot, 
  setScreenshot 
}) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        toast.error('File size exceeds 5MB limit');
        return;
      }
      setScreenshot(file);
    }
  };

  return (
    <div className="space-y-2">
      <FormLabel>Screenshot (optional)</FormLabel>
      <div className="flex items-center gap-2 border rounded-md p-2">
        <Input
          type="file"
          id="screenshot"
          className="hidden"
          accept="image/*"
          onChange={handleFileChange}
        />
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => document.getElementById('screenshot')?.click()}
        >
          <Upload className="h-4 w-4 mr-2" />
          Upload Image
        </Button>
        {screenshot && (
          <span className="text-sm text-muted-foreground">
            {screenshot.name} ({Math.round(screenshot.size / 1024)} KB)
          </span>
        )}
      </div>
    </div>
  );
};
